import { createReducer } from '@ngrx/store';
import { MapResultsState } from '@immosky/types';
import { immerOn } from 'ngrx-immer/store';
import {
  resetMapRealEstateObjects,
  setMapRealEstateObjects,
} from './map-results.actions';

export const initialState: MapResultsState = {
  results: [],
};

export const mapResultsReducer = createReducer(
  initialState,
  immerOn(setMapRealEstateObjects, (state, { objects }) => {
    state.results = objects;
  }),
  immerOn(resetMapRealEstateObjects, (state) => {
    state.results = [];
  })
);
